import "./Heading.scss";

function Heading(props) {
  const CustomTag = props.level;

  return <CustomTag className={props.type}>{props.title}</CustomTag>;
}

export default Heading;
